import { render } from "./FormSection.vue?vue&type=template&id=0c352ec0&scoped=true"
import script from "./FormSection.vue?vue&type=script&lang=js"
export * from "./FormSection.vue?vue&type=script&lang=js"

import "./FormSection.vue?vue&type=style&index=0&id=0c352ec0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0c352ec0"

export default script